import { useLocation, useRoutes } from "react-router-dom";
import routes from "./config";
import CompareBar from "@/components/feature/CompareBar";
import MaintenancePage from "@/components/base/MaintenancePage";
import { useSystemSettings } from "@/context/SystemSettingsContext";

export function AppRoutes() {
  const element = useRoutes(routes);
  const location = useLocation();
  const { settings, loaded } = useSystemSettings();

  const bypassMaintenance = location.pathname.startsWith('/admin');
  const maintenanceEnabled = loaded && settings.maintenance.enabled && !bypassMaintenance;

  if (!loaded && !bypassMaintenance) {
    return (
      <div className="min-h-screen bg-[#07101C] flex items-center justify-center px-6">
        <div className="text-center text-white">
          <div
            className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full"
            style={{ backgroundColor: 'color-mix(in srgb, var(--accent) 16%, transparent)' }}
          >
            <i className="ri-loader-4-line animate-spin text-2xl" style={{ color: 'var(--accent)' }}></i>
          </div>
          <p className="text-sm font-semibold tracking-wide uppercase text-white/60">Loading Stingray</p>
        </div>
      </div>
    );
  }

  if (maintenanceEnabled) {
    return (
      <MaintenancePage
        title={settings.maintenance.title}
        message={settings.maintenance.message}
      />
    );
  }

  return (
    <>
      {element}
      <CompareBar />
    </>
  );
}
